import React, { Component } from 'react';

class ResultsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    addResults = (data, key) => {
        let dataArr = [];
        if (key === 'actual&direct') {
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "direct") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
        if(key === 'actual&Indirect'){
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "indirect") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
        if(key === 'actual&complement'){
            data.map((item, index) => {
                if (item.type === "actual" && item.indirect === "complement") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
        if (key === 'potential&direct') {
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "direct") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
        if(key === 'potential&Indirect'){
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "indirect") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
        if(key === 'potential&complement'){
            data.map((item, index) => {
                if (item.type === "potential" && item.indirect === "complement") {
                    dataArr.push(<li key={index}>{item.competitorName} <input type="checkbox" style={{float: "right"}} checked={item.important} onClick={()=>this.props.changeCompetitorsGroupsImportant(item.competitorId)}/></li>)
                }
            })
            return dataArr
        }
    }
    render() {
        return (
            <table cellSpacing="0" className="resultsTable">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Direct</th>
                        <th>Indirect</th>
                        <th>Complement</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td align="right">Actual</td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'actual&direct')}
                            </ul>
                        </td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'actual&Indirect')}
                            </ul>
                        </td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'actual&complement')}
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td align="right">Potential</td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'potential&direct')}
                            </ul>
                        </td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'potential&Indirect')}
                            </ul>
                        </td>
                        <td valign="top">
                            <ul>
                                {this.addResults(this.props.data.Items[0].competitors, 'potential&complement')}
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>

        )
    }
}

export default (ResultsTable);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CopmpetitorsGroupsImportant/CompetitorsTable/CompetitorsTable.jsx